import InstallmentSettingList from "./List";
import InstallmentSettingCreate from "./Create";

const InstallmentSetting = {
  List: InstallmentSettingList,
  Create: InstallmentSettingCreate,
};

export default InstallmentSetting;
